/**
 * @flow
 */
import styled from 'react-emotion'
import { Typo13White2RR, Typo14White2RR } from '../../../../themes/Fonts'
import colors from '../../../../themes/Colors'
import { mobile, desktop } from '../../../../utils/mixins'

export const BookingDetailsContainer = styled('div')`
  font-size: 16px;
  padding-top: 3.5em;
  padding-bottom: 1.875em;

  @media (min-width: 320px) and (max-width: 1200px) {
    padding-top: 0;
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    width: 26em;
    margin: auto;
  }
  ${mobile} {
    padding-bottom: 14px;
  }
  ${desktop} {
    margin-right: 28px;
  }
`
export const BookingDetailsInnerContainer = styled('div')`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media (min-width: 320px) and (max-width: 767px) {
    padding-left: 1.875em;
    padding-right: 1.875em;
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
  }
`
export const BookingWrapper = styled('div')``
export const DetailsContainer = styled('div')``

const Typo13White2RRWithArticleTag = Typo13White2RR.withComponent('article')
const Typo14White2RRWIthArticleTag = Typo14White2RR.withComponent('article')
export const BookingDetailsText = styled(Typo13White2RRWithArticleTag)`
  opacity: 0.5;
  text-align: left;
  padding-bottom: 0.75em;
  @media (min-width: 768px) and (max-width: 1024px) {
    padding-bottom: 0.5em;
  }
  font-family: din-2014;
`
export const ContactNameContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const ContactText = styled(Typo14White2RRWIthArticleTag)`
  padding-left: 0.429em;
  font-family: din-2014;
`
export const MobileText = styled(Typo14White2RRWIthArticleTag)`
  padding-left: 0.571em;
  font-family: din-2014;
`

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 0.5em;
`

export const PackageText = styled(Typo14White2RRWIthArticleTag)`
  font-family: din-2014;
`

export const MobileNumberContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 0.5em;
`
export const ContactMembersContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 0.5em;
`

export const MembersCountText = styled(Typo14White2RRWIthArticleTag)`
  padding-left: 0.286em;
  font-family: din-2014;
`
export const CalendarText = styled(Typo14White2RRWIthArticleTag)`
  padding-left: 0.5em;
  font-family: din-2014;
`
export const CalendarContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 0.5em;
`
export const ContinueButtonText = styled(Typo14White2RRWIthArticleTag)`
  font-family: din-2014;
`
export const ContinueButtonContainer = styled('div')`
  user-select: none;
  width: 12.875em;
  height: 2.5em;
  border-radius: 2px;
  background-color: ${colors.whiteTwo10};
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 1.5em;
  cursor: pointer;
  @media (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    margin-bottom: 1em;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    margin: 0;
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    margin: 0;
    margin-top: 1.5em;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/BookingDetails/styledComponents.js